<template>
  <div>
    <div class="width100">
      <headerBackground v-bind="partData" />
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-10 mx-auto">
            <div v-if="$route.params.partId == null">
              <div v-if="cabinetList != undefined && cabinetList.length > 0">
                <div v-for="(cabinet, index) in cabinetList" :key="'cabinet' + index" class="pb-4">
                  <router-link :to="'/personalcabinet/' + cabinet.id.toString()">
                    <div class="d-flex justify-content-center align-items-center pb-4"
                      :style="'min-height:300px; background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(' + cabinetImage(cabinet.id.toString()) + ') no-repeat center; background-size: cover;'">
                      <div class="text-center text-light">
                        <h4 class="p-2">{{ cabinet.name }}</h4>
                        <h6 class="p-2">{{ cabinet.description }}</h6>
                      </div>
                    </div>
                  </router-link>
                  <!-- <hr> -->
                </div>
              </div>
              <div v-else-if="cabinetList !== null">
                <h2>
                  Пока у Вас нет курсов!
                </h2>
                Бесплатные курсы можно добавить по <a href="/freecourses">ссылке {{ '-->' }}</a><br>
                Пройти викторину можно по <a href="/questtest">ссылке {{ '-->' }}</a>
              </div>
            </div>
            <div v-else>
              <breadСrumbsLight />
              <div class="pb-5 text-start">
                <h2 @click="goBack" class="post-title go-back">Назад</h2>
              </div>

              <div v-for="(part, index) in partsList" :key="'part' + index" class="text-start">
                <div class="post-preview pb-5">
                  <b-icon v-if="part.pass == 1" icon="check-circle-fill" variant="success" font-scale="1"
                    class="me-1 check-content"></b-icon>
                  <b-icon v-if="part.pass == 0" icon="arrow-right-circle-fill" variant="dark" font-scale="1"
                    class="me-1 check-content"></b-icon>

                  <router-link v-if="part.pass !== null" :to="'/personalcabinet/' + part.id">
                    <h2 class="post-title">
                      <div class="folder-too">
                        <b-icon icon="folder-fill" font-scale="1" variant="warning" class="me-1 icon-folder"></b-icon>
                        <b-icon icon="folder" font-scale="1" variant="secondary" class="me-1 icon-folder"></b-icon>
                      </div>
                      <!-- <b-icon icon="folder-fill" font-scale="1" variant="warning"
                        class="me-1"></b-icon> -->
                      {{ part.menu }} {{ part.name }}
                    </h2>
                    <h5 class="post-subtitle">{{ part.description }}</h5>
                  </router-link>

                  <div v-else class="text-secondary">
                    <h2 class="post-title"><b-icon icon="folder" font-scale="1" class="me-1"></b-icon>
                      {{ part.menu }} {{ part.name }}</h2>
                    <h5 class="post-subtitle">{{ part.description }}</h5>
                  </div>
                </div>
              </div>
              <div v-for="(lecture, index) in lecturesList" :key="'lecture' + index" class="text-start">
                <b-icon v-if="lecture.pass == 1" icon="check-circle-fill" variant="success" font-scale="1"
                  class="me-1 check-content-min"></b-icon>
                <b-icon v-if="lecture.pass == 0" icon="arrow-right-circle-fill" variant="dark" font-scale="1"
                  class="me-1 check-content-min"></b-icon>
                <div class="post-preview pb-5">
                  <router-link v-if="lecture.pass !== null" :to="'/lecture/' + lecture.id">
                    <h3 class="post-title">
                      <div class="book-too">
                        <b-icon icon="book-fill" font-scale="1" class="me-1 icon-book purple"></b-icon>
                        <b-icon icon="book" font-scale="1" variant="secondary" class="me-1 icon-book"></b-icon>
                      </div>
                      Лекция
                      {{
                        lecture.name
                      }}
                    </h3>
                    <h5 class="post-subtitle">{{ lecture.description }}</h5>
                  </router-link>
                  <div v-else class="text-secondary">
                    <h3 class="post-title"><b-icon icon="book" font-scale="1" class="me-1"></b-icon>
                      Лекция
                      {{
                        lecture.name
                      }}</h3>
                    <h5 class="post-subtitle">{{ lecture.description }}</h5>
                  </div>
                </div>
              </div>
              <div v-for="(test, index) in testsList" :key="'test' + index" class="text-start">
                <b-icon v-if="test.pass == 1 && test.active != 0" icon="check-circle-fill" variant="success" font-scale="1"
                  class="me-1 check-content"></b-icon>
                <b-icon v-if="test.pass == 0 && test.active != 0" icon="arrow-right-circle-fill" variant="dark" font-scale="1"
                  class="me-1 check-content"></b-icon>
                <div class="post-preview pb-5">
                  <router-link v-if="test.attempts !== null && test.active != 0" :to="'/test/' + test.id">
                    <h2 class="post-title"><b-icon icon="patch-question-fill" font-scale="1" variant="primary"
                        class="me-1"></b-icon>
                      {{ test.final == 1 ? 'Итоговый тест ' : test.menu }} {{ test.name }}</h2>
                    <h5 class="post-subtitle">Осталось попыток: {{ test.attempts }} из {{ test.count }}</h5>
                  </router-link>
                  <div v-else class="text-secondary">
                    <h2 class="post-title"><b-icon icon="patch-question" font-scale="1" class="me-1"></b-icon>
                      {{ test.final == 1 ? 'Итоговый тест ' : test.menu }} {{ test.name }}</h2>
                    <h5 class="post-subtitle">Всего попыток: {{ test.count }}</h5>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="clearfix">
            <nav>
              <ul class="pagination">
                <li class="page-item active"><span class="page-link">1</span></li>
                <li class="page-item"><a class="page-link" href="about/2">2</a></li>
                <li class="page-item"><a class="page-link" href="/system/courses/2">Вперед</a></li>
              </ul>
            </nav>
          </div> -->
          </div>
        </div>
      </div>
    </div>
    <cabinetFooter />
  </div>
</template>
<script>
import headerBackground from '@/components/headerBackground.vue'
import cabinetFooter from '@/components/cabinetFooter.vue'
import breadСrumbsLight from '@/components/breadСrumbsLight.vue'
import md5 from 'js-md5'

export default {
  components: {
    headerBackground,
    cabinetFooter,
    breadСrumbsLight
  },
  data() {
    return {
      cabinetList: null,
      partsList: {},
      lecturesList: {},
      testsList: {},
      partData: {}
    }
  },
  methods: {
    cabinetImage(id) {
      return this.$store.getters.URL + '/public/materials/' + md5(id) + '/' + id + '.jpg';
    },
    goBack() {
      if (this.$store.getters.BREADCRUMBS.length > 1) {
        this.$router.push({ path: `/personalcabinet/${this.$store.getters.BREADCRUMBS[this.$store.getters.BREADCRUMBS.length - 2].id}` });
      } else {
        this.$router.push({ path: `/personalcabinet/` });
      }
      // this.$router.go(-1);
    },
    getChildrenList() {
      if (this.$route.params.partId) {
        this.partsList = {};
        this.lecturesList = {};
        this.testsList = {};
        this.partData = {};
        this.axios
          .get(this.$store.getters.URL + '/api/part/' + this.$route.params.partId)
          .then(response =>
          (
            this.partsList = response.data.partsList,
            this.lecturesList = response.data.lecturesList,
            this.testsList = response.data.testsList,
            this.partData = response.data.partData,
            this.$store.commit('breadCrumbsSet', response.data.breadCrumbs)
          ))
          // .catch(function (error) {
          //   console.log(error);
          // })
          ;
      }
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.getChildrenList()
      },
      deep: true
    }
  },

  mounted() {
    this.getChildrenList();
    this.cabinetList = null;
    this.axios
      .get(this.$store.getters.URL + '/api/cabinet')
      .then(response => (this.cabinetList = response.data.cabinetList,
        this.$store.commit('reDirect', response.data.redirect)
      ))
      // .catch(function (error) {
      //   console.log(error);
      // })
      ;
  },
}
</script>
<style>
.post-preview>a {
  color: #333
}

.post-preview>a:focus,
.post-preview>a:hover {
  text-decoration: none;
  color: #6a0583
}

h2 .post-title {
  font-size: 36px;
  margin-top: 30px;
  margin-bottom: 10px;
  text-decoration: none;
}



h5 .post-subtitle {
  font-size: 1.25rem;
  font-weight: 300;
  margin: 0 0 10px;
  text-decoration: none;
}

/* @media only screen and (min-width:768px) {
  .post-preview .post-title {
    font-size: 36px
  }
} */

.check-content {
  position: relative;
  left: -40px;
  width: 20px;
  top: 36px;
}

.check-content-min {
  position: relative;
  left: -40px;
  width: 20px;
  top: 32px;
}

.text-secondary {
  --bs-text-opacity: 0.5 !important;
}

.book-too {
  display: inline-block;
  width: 35px;
  position: relative;
  top: 0;
}

.icon-book {
  position: absolute;
  left: 0;
  top: -22px;
}

.folder-too {
  display: inline-block;
  width: 35px;
  position: relative;
  top: 0;
}

.icon-folder {
  position: absolute;
  left: 0;
  top: -26px;
}

.purple {
  color: #cecece;
}
</style>
